// extracted by mini-css-extract-plugin
export default {"txt":"Txt_txt__nPP9v"};